module.exports = require("core-js/library/fn/symbol");


//////////////////
// WEBPACK FOOTER
// ./node_modules/@babel/runtime-corejs2/core-js/symbol.js
// module id = 74
// module chunks = 0 1